import { createPortal } from 'react-dom'

import { Modal } from 'react-bootstrap'
import { KTSVG } from '_metronic/helpers'
import { ClientSideTable } from 'Presentation/Components/Table'
import FileCard from './Components/FileCard'

import useViewModel from './ViewModel'

const ProjectImportView: React.FC = () => {
  const {
    modalsRoot,
    isOpenImportProjectModal,
    files,
    isUpload,
    handleClose,
    handleUploadSeveralFiles,
    removeFile,
    handleImport,
    data,
    TABLE_CONFIGS,
  } = useViewModel()

  return createPortal(
    <Modal
      id='kt_modal_project_import'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog modal-dialog-centered modal-dialog-scrollable mw-900px'
      show={isOpenImportProjectModal}
      onHide={handleClose}
      backdrop={true}>
      <div className='modal-content'>
        <div className='modal-header'>
          <h2>Import Project</h2>
          {/* begin::Close */}
          <div className='btn btn-sm btn-icon btn-active-light-danger' onClick={handleClose}>
            <KTSVG className='svg-icon-1' path='/media/icons/duotune/general/gen040.svg' />
          </div>
          {/* end::Close */}
        </div>

        <div className='modal-body py-lg-10 px-lg-10 min-h-500px'>
          {!isUpload && (
            <>
              {/* begin:: Input */}
              <div
                className='border-dashed w-100 h-150px bg-hover-light transition-500'
                onClick={() => {
                  document.getElementById('sale-order-import-input')?.click()
                }}>
                <div className='d-flex flex-column align-items-center justify-content-center h-100 cursor-pointer'>
                  <KTSVG
                    className='svg-icon-5x svg-icon-primary'
                    path='/media/icons/duotune/general/gen006.svg'
                  />

                  <p className='text-gray-500 fw-bold fs-3 mb-5 mt-5'>Browse Files</p>
                  <p className='text-gray-400'>Supports: XLSX, XLS, CSV</p>

                  <input
                    id='sale-order-import-input'
                    type='file'
                    className='d-none'
                    multiple
                    accept='.xlsx, .xls, .csv'
                    onChange={(e: any) => {
                      handleUploadSeveralFiles(e)

                      // @ts-ignore
                      e.target.value = null
                    }}
                  />
                </div>
              </div>
              {/* end:: Input */}

              {/* begin:: Files */}
              <div className='mt-5 row gy-5'>
                {files.map((file, index) => (
                  <div className='col-12' key={'file-upload-sale-order-' + index}>
                    <FileCard file={file} removeFile={() => removeFile(index)} />
                  </div>
                ))}
              </div>
              {/* end:: Files */}
            </>
          )}

          {isUpload && (
            <ClientSideTable data={data} columns={TABLE_CONFIGS} items_per_page={1000} />
          )}
        </div>

        <div className='modal-footer'>
          {!isUpload && (
            <>
              <button className='btn btn-sm btn-light' onClick={handleClose}>
                Cancel
              </button>
              <button className='btn btn-sm btn-primary' onClick={handleImport}>
                Import
              </button>
            </>
          )}

          {isUpload && (
            <>
              <button className='btn btn-sm btn-muted' onClick={handleClose}>
                Cancel
              </button>
              <button className='btn btn-sm btn-primary' onClick={handleClose}>
                Confirm
              </button>
            </>
          )}
        </div>
      </div>
    </Modal>,
    modalsRoot
  )
}

export default ProjectImportView
